/**
 * Proxied Finnhub-style API via Netlify Functions (keys stay on the server).
 */

function functionsUrl(name, params) {
  const u = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null) u.set(k, String(v));
  });
  const q = u.toString();
  return `/.netlify/functions/${name}${q ? `?${q}` : ''}`;
}

async function parseResponse(res) {
  const text = await res.text();
  let body;
  try {
    body = text ? JSON.parse(text) : {};
  } catch {
    body = { message: text };
  }
  if (!res.ok) {
    const msg =
      body.message ||
      body.error ||
      `Error ${res.status}${typeof body === 'string' ? `: ${body}` : ''}`;
    throw new Error(msg);
  }
  return body;
}

/** GET /.netlify/functions/stock-search */
export async function stockSearch(query) {
  const q = (query || '').trim();
  if (q.length < 1) return [];
  const res = await fetch(functionsUrl('stock-search', { query: q }));
  return parseResponse(res);
}

/** GET /.netlify/functions/stock-quote — returns { price, change, changePercent } */
export async function stockQuote(ticker) {
  const res = await fetch(
    functionsUrl('stock-quote', { ticker: ticker.trim().toUpperCase() })
  );
  return parseResponse(res);
}

/** GET /.netlify/functions/stock-score — full scored payload */
export async function fetchStockScore(ticker) {
  const res = await fetch(
    functionsUrl('stock-score', { ticker: ticker.trim().toUpperCase() })
  );
  return parseResponse(res);
}
